import { Button, Card, Col, ColorPicker, Divider, Dropdown, Flex, Form, Input, InputNumber, Layout, MenuProps, Popconfirm, Radio, RadioChangeEvent, Row, Select, Slider, Space, Switch, Tooltip, message } from "antd";
import parse from 'html-react-parser';
import { AlertCircle, AlignCenter, AlignLeft, AlignRight, ArrowDownNarrowWide, ArrowDownToLine, ArrowUpNarrowWide, ArrowUpToLine, Bold, BoxSelect, CaseSensitive, Copy, Download, Image as ImageIcon, Italic, Layers3, Minus, MoreHorizontal, PaintBucket, Plus, PlusIcon, Redo2, Sun, TextCursorInput, Trash2, Type, Undo2, ZoomIn, ZoomOut } from "lucide-react";
// import { createClient } from "pexels";
import { IconAlignBoxCenterBottom, IconAlignBoxCenterMiddle, IconAlignBoxCenterTop, IconArrowAutofitHeight, IconArrowAutofitWidth, IconArrowsUpDown, IconChevronLeft, IconCloudDownload, IconCloudUpload, IconKeyframes, IconLineHeight, IconLock, IconLockOpen, IconMaximizeOff, IconStack2, IconTemplate, IconTrash, IconTriangleSquareCircle } from '@tabler/icons-react';
import TextArea from "antd/es/input/TextArea";
import { useEffect, useReducer, useRef, useState } from "react";
import { flushSync } from "react-dom";
import { Helmet } from "react-helmet";
import Moveable from "react-moveable";
import Masonry from "react-responsive-masonry";
import { NavLink, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import Sortable from "sortablejs";
import WebFont from "webfontloader";
import AuthApi from "../../api/AuthApi";
import TemplateApi from "../../api/TemplateApi";
import RenderApi from "../../api/V1Api";
import { env } from "../../env/env";
import { CategoryDto, TemplateDto } from "../../generated/edithor-client";
import { templateState, userState } from "../../state/atoms";
import Storage from "../../util/Storage";
import { GoogleFonts } from "../../util/fonts";
import { download, getComponentBackgroundColor, getComponentBorderColor, getComponentBorderRadius, getComponentBorderWidth, getComponentColor, getComponentFontFamily, getComponentFontSize, getComponentLetterSpacing, getComponentLineHeight, getComponentOpacity, getComponentPadding, getComponentRenderDirections, getComponentShapeFillColor, getComponentShapeLineColor, getComponentShapeLineRadius, getComponentShapeLineWidth, getComponentTextAlign, getComponentTextVerticalAlign, getComponentType, isCanvas, isComponentBold, isComponentItalic, isComponentLocked, getComponentTextAutoFit, isComponentUppercase, isContentArea, isImage, isInput, isShape, isText } from "../../util/utils";
import LoaderBlocks from "../LoaderBlocks";
import LogoIcon from "../LogoIcon";
import DimensionViewable from "../canvas/ables/DimensionViewable";
import { dragComponent, resizeComponent, rotateComponent, updateDimentions, updateZoom } from "../canvas/canvas";
import history from '../canvas/history';
import AsideImages from "../editor/AsideImages";
import AsideUploads from "../editor/AsideUploads";
import "./Editor.scss";
import "./Moveable.scss";
import "../../static/fonts/fonts.css";
import AsideTemplatesGallery from "../editor/AsideTemplatesGallery";
import { debounce } from "lodash";

// const pexelsClient = createClient('8vfJGIg0Ues3OCCFevQhZzYIVc2JIHtxAIg2RADcXr6omkd82uUL4C0s');

const EMPTY_CANVAS_HTML = `<div id="canvas" spellcheck="false" style="width: 800px; height: 800px;"></div>`;
const DEMO_HTML = `<div id="canvas" spellcheck="false" style="width: 1000px; height: 600px; transform: scale(0.66);"><div class="component image" id="b5rvqdy3ryh" name="image-2" style="width: 1115px; height: 669px; transform: translate(-20.0641px, -34.5px);"><img src="https://templated-assets.s3.amazonaws.com/public/pixabay-images/455338" alt="mountaineering, man, trail" draggable="false"></div><div class="component shape" id="mvrndu5fkss" name="shape-1" style="width: 207px; height: 181px; transform: translate(170.742px, 247.204px) rotate(-19deg) scale(3.44212, 4.4912); opacity: 0.4;"><svg width="207px" height="181px" viewBox="0 0 207 181" style="width: 207px; height: 181px;"><rect fill="#0d0d0d" stroke="#050505" stroke-width="5" x="0" y="0" width="207" height="181" fill-opacity="1" stroke-opacity="1"></rect></svg></div><div class="component text" id="dum9xbmi1l" name="text-1" style="width: 733px; height: 259px; transform: translate(47.4697px, 133.099px); color: rgb(255, 255, 255); font-family: Cabin; font-weight: bold;"><p contenteditable="false" style="font-size: 90px; line-height: 0.96em; letter-spacing: 2px;">Exploring the Wonders of Patagonia</p></div><div class="component text" id="drqfydvmlc" name="text-2" style="width: 233px; height: 45px; transform: translate(49.3571px, 63.6061px); color: rgb(255, 255, 255); text-align: center; font-family: ABeeZee; font-weight: bold;"><p contenteditable="false" style="font-size: 25px; border-color: rgb(255, 255, 255); border-width: 1px; border-radius: 0px; background-color: rgba(217, 196, 196, 0); padding: 6px; line-height: 1.25em;">10 MIN READ</p></div><div class="component image" id="fr6ukgo3uga" name="image-2" style="width: 114px; height: 118px; transform: translate(49.3939px, 436.273px); border-color: rgb(255, 255, 255); border-width: 2px; border-radius: 47px;"><img src="https://templated-assets.s3.amazonaws.com/public/pixabay-images/7751688" alt="ai generated, man, profile" draggable="false"></div><div class="component text" id="rv5xq19dste" name="text-3" style="width: 332px; height: 35px; transform: translate(176.121px, 447.818px); color: rgb(252, 252, 252); font-weight: bold; font-style: italic;"><p contenteditable="false" style="font-size: 25px;">Adventure Travelers</p></div><div class="component text" id="fwwne17f3iq" name="text-4" style="width: 289px; height: 28px; transform: translate(176.182px, 490.818px); color: rgb(255, 255, 255); font-family: &quot;Noto Sans&quot;; font-weight: bold; font-style: normal;"><p contenteditable="false" style="font-size: 20px;">December 5, 2023</p></div></div>`;
const DEMO_MESSAGE = <>This is just a demo version of our Template Editor. <br />Sign up and try more <a href="/" target="_blank">here</a>.</>

let undo: any = undefined;
let redo: any = undefined;

const { Header, Sider, Content } = Layout;
const { Option } = Select;

export interface EditorProps {
}

export default function Editor({ }: EditorProps) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [_, forceUpdate] = useReducer(x => x + 1, 0);
  const [messageApi, contextHolder] = message.useMessage();

  const { id } = useParams();
  const master = searchParams.get("master");
  const demo = searchParams.get("demo");
  const [user, setUser] = useRecoilState(userState);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [activeSidebarTab, setActiveSidebarTab] = useState('templates-gallery');

  const [html, setHtml] = useState("");

  const [template, setTemplate] = useRecoilState(templateState);
  const [categories, setCategories] = useState<CategoryDto[]>([]);

  const selectedComponent = useRef<HTMLElement | undefined>(undefined);
  const [components, setComponents] = useState<NodeListOf<HTMLElement> | undefined>();

  const targetRef = useRef<any>(null);
  const containerRef = useRef<any>(null);
  const moveableRef = useRef<any>(null);
  const sortableRef = useRef<any>(null);

  // Moveable dynamic properties
  const [keepRatio, setKeepRatio] = useState(false);
  const [renderDirections, setRenderDirections] = useState<string[]>([]);
  const [showDimensionViewable, setShowDimensionViewable] = useState(false);

  // Component state
  const [zoom, setZoom] = useState(50);
  const [type, setType] = useState('');
  const [isLocked, setIsLocked] = useState(false);
  const [isBold, setIsBold] = useState(true);
  const [isItalic, setIsItalic] = useState(true);
  const [isUppercase, setIsUppercase] = useState(true);
  const [textAutoFit, setTextAutoFit] = useState("");
  const [textAlign, setTextAlign] = useState('left');
  const [textVerticalAlign, setTextVerticalAlign] = useState('start');
  const [opacity, setOpacity] = useState(100);
  const [fontFamily, setFontFamily] = useState('Noto Sans');
  const [fontSize, setFontSize] = useState(0);
  const [letterSpacing, setLetterSpacing] = useState(0);
  const [lineHeight, setLineHeight] = useState(0);
  const [color, setColor] = useState('');
  const [backgroundColor, setBackgroundColor] = useState('');
  const [padding, setPadding] = useState(0);
  const [borderColor, setBorderColor] = useState('');
  const [borderWidth, setBorderWidth] = useState(0);
  const [borderRadius, setBorderRadius] = useState(0);
  const [shapeLineColor, setShapeLineColor] = useState('');
  const [shapeFillColor, setShapeFillColor] = useState('');
  const [shapeLineWidth, setShapeLineWidth] = useState(0);
  const [shapeLineRadius, setShapeLineRadius] = useState(0);

  const [fontSelectOpen, setFontSelectOpen] = useState(false);
  const fonts = GoogleFonts;

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    WebFont.load({
      google: {
        families: GoogleFonts,
      },
    });
  }, []);

  // useEffect(() => {
  //   if (categories.length === 0) {
  //     CategoryApi.getAll().then(resp => {
  //       setCategories(resp.data);
  //     });
  //   }
  // }, []);

  useEffect(() => {
    if (!demo) {
      if (Storage.getToken()) {
        // setAppLoading(true);

        if (!user.id) {
          AuthApi.auth().then(resp => {
            if (resp.data) {
              const user = resp.data
              if (user.id) {
                setUser(user)
              }

              // setAppLoading(false);
              // navigate('/')
            } else {
              navigate('/');
            }
          })
        }
      } else {
        navigate('/');
      };
    }
  }, []);

  useEffect(() => {
    if (demo) {
      setHtml(DEMO_HTML);
      setTemplate({
        name: 'Demo Template',
        width: 1000,
        height: 1000,
      })
      setLoading(false);
    } else {
      if (user.id) {
        if (master) {
          setLoading(true);

          TemplateApi.createFromMaster(master, user.id).then(resp => {
            if (resp.data) {
              window.location.href = `/editor/${resp.data.id}`;
            }
          });

        } else {
          setLoading(true);

          if (id) {
            // Load existing Template
            TemplateApi.get(id).then(resp => {
              if (resp.data) {
                setTemplate(resp.data);
                setHtml(resp.data.html || EMPTY_CANVAS_HTML);
                setActiveSidebarTab(resp.data.html ? "text" : "templates-gallery");
                setLoading(false);
              }
            });
          } else {
            // Create new Template
            const content = document.querySelector('#canvas');

            const newTemplate = {
              name: 'Unnamed Template',
              width: 800,
              height: 800,
              userId: user.id!,
              html: content ? content.outerHTML : ""
            } as TemplateDto;

            TemplateApi.create(newTemplate).then(resp => {
              if (resp.data) {
                setTemplate(resp.data)
                setLoading(false);
                navigate(`/editor/${resp.data.id}`);
                setHtml(EMPTY_CANVAS_HTML);
              }
            });
          }
        }
      }
    }
  }, [user])


  useEffect(() => {
    // if (html != EMPTY_CANVAS_HTML) {
    initEventListeners();
    // }
    initSortable();
  }, [html])

  function initEventListeners(newComponent: HTMLElement | undefined = undefined) {
    const comps = document.querySelectorAll('.component') as NodeListOf<HTMLElement>;

    if (newComponent) {
      setTimeout(() => {
        newComponent.addEventListener('mousedown', (ev: any) => {
          select(newComponent);
          // moveableRef.current.updateRect();

          moveableRef.current.waitToChangeTarget().then(() => {
            // console.log(moveableRef.current);
            // console.log(ev.target);
            moveableRef.current.dragStart(ev);
          });
          ev.stopPropagation();
        })
      }, 1500);

      newComponent.addEventListener('dblclick', () => {
        console.log('double-click');
        if (isText(newComponent)) {
          const p = newComponent!.querySelector('p')!
          p.contentEditable = "true";
          p.focus();
          // Select all text in the content-editable element
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(p);
          selection!.removeAllRanges();
          selection!.addRange(range);
        }
      });

      newComponent.addEventListener('keydown', () => {
        console.log('keydown');

        if (isText(newComponent)) {
          const p = selectedComponent.current!.querySelector('p')!
          selectedComponent.current!.style.height = `${p.offsetHeight}px`;
          moveableRef.current.updateRect();
        }
      });

      if (isText(newComponent)) {
        newComponent!.querySelector('p')!.addEventListener('keydown', function (event: any) {
          if (event.key === 'Enter') {
            event.preventDefault();

            var selection = window.getSelection()!;
            var range = selection.getRangeAt(0);
            var br = document.createElement('br');

            range.deleteContents();
            range.insertNode(br);

            range.setStartAfter(br);
            range.setEndAfter(br);
            selection.removeAllRanges();
            selection.addRange(range);
          }
        });
      }

      setComponents(comps);
    } else {
      const canvas = document.getElementById("canvas");
      const content = document.getElementsByClassName("content")[0];

      // Add content area's events
      if (content) {
        content.addEventListener('mousedown', (ev) => {
          if (isContentArea(ev.target)) {
            select(undefined);
            ev.stopPropagation();
          }
        });
      }

      // Add canvas' events
      if (canvas) {
        canvas.addEventListener('mousedown', (ev) => {
          if (isCanvas(ev.target)) {
            selectedComponent.current = canvas;
            select(canvas);
            targetRef.current = undefined;
            ev.stopPropagation();
          }
        });
      }

      // Add components' events
      comps.forEach(component => {
        component.addEventListener('mousedown', (ev: any) => {
          select(component);
          forceUpdate();
          moveableRef.current.waitToChangeTarget().then(() => {
            moveableRef.current.dragStart(ev);
          });

          ev.stopPropagation();
        });

        component.addEventListener('dblclick', (ev) => {
          console.log('double-click');
          if (isText(component)) {
            const p = component!.querySelector('p')!
            p.contentEditable = "true";
            p.focus();
            // Select all text in the content-editable element
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(p);
            selection!.removeAllRanges();
            selection!.addRange(range);
          }
        });

        component.addEventListener('keydown', (ev) => {
          console.log('keydown');

          if (isText(component)) {
            const p = component!.querySelector('p')!
            component!.style.height = `${p.offsetHeight}px`;
            moveableRef.current.updateRect();
          }
        });
      })

      // Keyboard events
      const keydownEvents = (ev: any) => {
        if ((ev.metaKey || ev.ctrlKey) && ev.key === "s") {
          ev.preventDefault();
          save();
        } else {
          switch (ev.key.toLowerCase()) {
            case 'backspace':
            case 'delete':
              if (selectedComponent.current && !isInput(ev.target)) {
                if (isText(selectedComponent.current)) {
                  const p = selectedComponent.current!.querySelector('p')!
                  if (p.contentEditable !== "true") {
                    deleteComponent();
                  }
                } else {
                  deleteComponent();
                }
              }
              break;
            case 'arrowup':
              ev.preventDefault();
              move('up');
              break;
            case 'arrowdown':
              ev.preventDefault();
              move('down');
              break;
            case 'arrowleft':
              // ev.preventDefault();
              move('left');
              break;
            case 'arrowright':
              // ev.preventDefault();
              move('right');
              break;
            case 'z':
              if (ev.ctrlKey || ev.metaKey) {
                if (ev.shiftKey) {
                  history.redo();
                } else {
                  history.undo();
                }
              }
              break;
            // case 's':
            //   if (ev.ctrlKey || ev.metaKey) {
            //     ev.preventDefault();
            //     save();
            //   }
            //   break;
            default:
              break;
          }
        }
      };

      document.removeEventListener("keydown", keydownEvents);
      document.addEventListener("keydown", keydownEvents);
      window.addEventListener('resize', () => { if (moveableRef.current) moveableRef.current.updateRect() });

      // Reset events
      document.addEventListener('click', (ev) => {
        const p = document.querySelector('p[contentEditable="true"]')! as any;

        if (p && !p.contains(ev.target)) {
          p.contentEditable = "false";
        }
      });

      document.querySelectorAll('.component.text > p').forEach(function (p) {
        p.addEventListener('keydown', function (event: any) {
          if (event.key === 'Enter') {
            event.preventDefault();

            var selection = window.getSelection()!;
            var range = selection.getRangeAt(0);
            var br = document.createElement('br');

            range.deleteContents();
            range.insertNode(br);

            range.setStartAfter(br);
            range.setEndAfter(br);
            selection.removeAllRanges();
            selection.addRange(range);
          }
        });
      });

      setComponents(comps);
    }
  }

  // function undo() {
  //   console.log('> undoing');

  //   if (undoStack.length > 1) {
  //     const currentState = undoStack.pop();
  //     redoStack.push(currentState);
  //     // Restore the state (e.g., set editor content, component properties, etc.)
  //   }
  // }

  // function redo() {
  //   console.log('> redoing');

  //   if (redoStack.length > 0) {
  //     const nextState = redoStack.pop();
  //     undoStack.push(nextState);
  //     // Restore the state (e.g., set editor content, component properties, etc.)
  //   }
  // }

  function insertAndShift(arr: Element[], from: number, to: number) {
    let cutOut = arr.splice(from, 1)[0];
    arr.splice(to, 0, cutOut);
  }

  function initSortable() {
    // Destroy the existing Sortable instance if it exists
    if (sortableRef.current) {
      sortableRef.current.destroy();
    }

    var layers = document.querySelector(".layers") as any;

    if (layers) {
      sortableRef.current = Sortable.create(layers,
        {
          animation: 200,
          direction: 'vertical',
          swapThreshold: 0.50,
          // handle: ".layer-handle"

          // onStart: function (ev) {
          //   select(ev.target);
          // },

          onEnd: function (ev) {
            let itemEl = ev.item;  // dragged HTMLElement
            const layerName = itemEl.querySelector(".layer-name")!.textContent!
            const canvas = document.getElementById("canvas")!;

            // // Get the index of the dropped element within .layers
            // const newIndex = Array.from(itemEl.parentElement!.children).indexOf(itemEl);

            // // Find the component based on layerName
            // const component = canvas.querySelector(`[name='${layerName}']`);

            // if (component) {
            // Reorder the components in the canvas (reversed order)
            const components = Array.from(document.querySelectorAll('.component')).reverse();

            // console.log(components)
            insertAndShift(components, ev.oldIndex!, ev.newIndex!)
            // console.log(components)

            // components.splice(components.indexOf(component), 1); // Remove the component
            // components.splice(newIndex, 0, component);
            // // components.unshift(component); // Insert at the beginning of the array

            // // Update the order of components in the canvas
            canvas.innerHTML = '';
            components.reverse().forEach((c) => canvas.appendChild(c));
            // setComponents(canvas.querySelectorAll('.component') as NodeListOf<HTMLElement>);
            // }


            // ev.to;    // target list
            // ev.from;  // previous list
            // ev.oldIndex;  // element's old index within old parent
            // ev.newIndex;  // element's new index within new parent
            // ev.oldDraggableIndex; // element's old index within old parent, only counting draggable elements
            // ev.newDraggableIndex; // element's new index within new parent, only counting draggable elements
            // ev.clone // the clone element
            // ev.pullMode;  // when item is in another sortable: `"clone"` if cloning, `true` if moving
          },
        }
      );
    }
  }

  function selectSidebar(sidebar: string) {
    if (sidebar === 'uploads') {
      if (demo) {
        messageApi.open({
          type: 'success',
          content: DEMO_MESSAGE,
        });
        return;
      }
    }

    setActiveSidebarTab(sidebar);
  }

  function getComponentsByType(type: string) {
    return document.querySelectorAll(`.component.${type}`)
  }

  function getNumberOfComponentsByType(type: string) {
    return getComponentsByType(type).length;
  }

  function addComponent(ev: any, type: string) {
    const canvas = document.querySelector('#canvas')!;
    const canvasRect = canvas.getBoundingClientRect();

    let newComponent = ev.currentTarget.cloneNode(true);
    newComponent.className = `component ${type}`;
    newComponent.id = Math.random().toString(36).slice(2);
    newComponent.setAttribute('name', `${type}-${getNumberOfComponentsByType(type) + 1}`);

    let width = 100;
    let height = 100 as any;

    if (type === "shape") {
      const svg = newComponent.querySelector('svg')!;
      const svgChild = svg.firstElementChild!;

      if (svgChild.nodeName.toLowerCase() === 'line') {
        height = "auto";
        // newComponent.className += " line";
      }
    }

    if (type === "image") {
      const img = ev.currentTarget.querySelector('img')!
      width = canvasRect.width / img.width * 10;
      height = canvasRect.width / img.width * 10;

      const aspectRatio = img.width / img.height;

      if (canvasRect.width / canvasRect.height < aspectRatio) {
        width = canvasRect.width * 0.6; // You can adjust the scaling factor as needed
        height = width / aspectRatio;
      } else {
        height = canvasRect.height * 0.6; // You can adjust the scaling factor as needed
        width = height * aspectRatio;
      }
    }

    if (type === "text") {
      const p = ev.currentTarget.querySelector('p')!
      const pComputedStyles = window.getComputedStyle(p);

      width = parseFloat(pComputedStyles.getPropertyValue('width'));
      height = parseFloat(pComputedStyles.getPropertyValue('height'));
    }

    newComponent.style.width = `${width}px`;
    newComponent.style.height = isNaN(height) ? height : `${height}px`;

    // Calculate translation values to center the component in the canvas
    const translateX = (canvasRect.width - parseFloat(newComponent.style.width)) / 2;
    const translateY = (canvasRect.height - parseFloat(newComponent.style.height)) / 2;
    newComponent.style.transform = `translate(${translateX}px, ${translateY}px)`;

    canvas.appendChild(newComponent);

    select(newComponent);
    targetRef.current = newComponent;
    selectedComponent.current = newComponent;
    setComponents(document.querySelectorAll('.component') as NodeListOf<HTMLElement>);

    initEventListeners(newComponent);
    initSortable();

    return newComponent;
  }

  function deleteComponent(component: HTMLElement | undefined = undefined) {
    if (!component && !targetRef.current) return;

    if (component) {
      component.remove();
    }

    selectedComponent.current = undefined;
    targetRef.current.remove();
    targetRef.current = null;
    moveableRef.current.updateTarget();
    setComponents(document.querySelectorAll('.component') as NodeListOf<HTMLElement>);
  }

  function renameComponent(component: HTMLElement) {
    const input = document.querySelector(`#rename-component-input-${component.id}`)! as any;
    component.setAttribute('name', input.value)
    messageApi.success(<>Layer renamed to <b>{input.value}</b></>);
  }

  function duplicateComponent(component: any) {
    const canvas = document.querySelector('#canvas')!;
    const canvasRect = canvas.getBoundingClientRect();

    let newComponent = component.cloneNode(true);
    newComponent.setAttribute('name', `${newComponent.getAttribute("name")}-2`)
    newComponent.id = Math.random().toString(36).slice(2);

    // Calculate translation values to center the component in the canvas
    const translateX = (canvasRect.width - parseFloat(newComponent.style.width)) / 2;
    const translateY = (canvasRect.height - parseFloat(newComponent.style.height)) / 2;
    newComponent.style.transform = `translate(${translateX}px, ${translateY}px)`;

    canvas.appendChild(newComponent);

    select(newComponent);
    targetRef.current = newComponent;
    selectedComponent.current = newComponent;
    setComponents(document.querySelectorAll('.component') as NodeListOf<HTMLElement>);

    initEventListeners(newComponent);
  }

  function onChangeTemplateName(ev: any) {
    const name = ev.target.value || ev.target.textContent;

    if (!name.trim()) {
      messageApi.open({
        type: 'warning',
        content: "Template name cannot be empty",
      });
      return;
    }

    setTemplate({ ...template, name: ev.target.value || ev.target.textContent });
  }

  function onChangeTemplateDescription(ev: any) {
    setTemplate({ ...template, description: ev.target.value });
  }

  function onChangeTemplateCategory(ev: any) {
    // setTemplate({ ...template, category: ev.target.value });
  }

  function onChangeTemplateTags(ev: any) {
    setTemplate({ ...template, tags: ev.target.value });
  }

  function onChangeTemplateWidth(value: any) {
    updateDimentions(value, template.height);
    setTemplate({ ...template, width: value });
  }

  function onChangeTemplateHeight(value: any) {
    updateDimentions(template.width, value);
    setTemplate({ ...template, height: value });
  }

  function downloadTemplate() {
    if (demo) {
      messageApi.open({
        type: 'success',
        content: DEMO_MESSAGE,
      });
      return;
    }

    setDownloading(true);

    messageApi.open({
      key: 'downloading',
      type: 'loading',
      content: <>Rendering <b>{template.name}</b>... <br /></>,
      duration: 0,
    });

    RenderApi.download(template.id!, user.apiKey!).then(resp => {
      download(`${env.s3Path}${resp.data.url}`, template.name, () => {
        setDownloading(false);
        messageApi.open({
          key: 'downloading',
          type: 'success',
          content: <>Done!</>,
          duration: 3,
        });
      });
    });
  }

  function save(callback: any = null) {
    if (demo) {
      messageApi.open({
        type: 'success',
        content: DEMO_MESSAGE,
      });
      return;
    }

    if (template.id) {
      setTemplate({ ...template, html: document.querySelector('#canvas')!.outerHTML });
      setSaving(true);

      TemplateApi.update({ ...template, html: document.querySelector('#canvas')!.outerHTML }).then(resp => {
        if (resp.data) {
          setTemplate(template)
          setSaving(false);

          messageApi.open({
            type: 'success',
            content: 'Saved',
          });

          if (!!callback) callback();
        }
      });
    }
  }

  function select(component: any) {
    targetRef.current = component;
    selectedComponent.current = component;

    if (component) {
      const type = getComponentType(component);
      setType(type);
      setRenderDirections(getComponentRenderDirections(type, component));

      setIsLocked(isComponentLocked(component));
      setIsBold(isComponentBold(component));
      setIsItalic(isComponentItalic(component));
      setIsUppercase(isComponentUppercase(component));
      setTextAutoFit(getComponentTextAutoFit(component));
      setOpacity(getComponentOpacity(component));
      setFontFamily(getComponentFontFamily(component));
      setFontSize(getComponentFontSize(component));
      setColor(getComponentColor(component));
      setTextAlign(getComponentTextAlign(component));
      setTextVerticalAlign(getComponentTextVerticalAlign(component));
      setLetterSpacing(getComponentLetterSpacing(component));
      setLineHeight(getComponentLineHeight(component));
      setBackgroundColor(getComponentBackgroundColor(component));
      setPadding(getComponentPadding(component));
      setBorderColor(getComponentBorderColor(component));
      setBorderWidth(getComponentBorderWidth(component));
      setBorderRadius(getComponentBorderRadius(component));
      setShapeLineColor(getComponentShapeLineColor(component));
      setShapeFillColor(getComponentShapeFillColor(component));
      setShapeLineWidth(getComponentShapeLineWidth(component));
      setShapeLineRadius(getComponentShapeLineRadius(component));
    } else {
      forceUpdate();
    }
  }

  function deselect() {
    selectedComponent.current = undefined;
    targetRef.current = null;
    moveableRef.current.updateTarget();
  }

  function toggleLocked() {
    const is = isComponentLocked(selectedComponent.current!);

    const doAction = (component: HTMLElement, is: boolean) => {
      setIsLocked(!is);
      component!.setAttribute("locked", (is ? 'false' : 'true'));
    }

    const redo = () => doAction(selectedComponent.current!, is);
    const undo = () => doAction(selectedComponent.current!, !is);

    redo();
    history.push(undo, redo, 'Lock');
  }

  function toggleBold() {
    const is = isComponentBold(selectedComponent.current!);

    const doAction = (component: HTMLElement, is: boolean) => {
      setIsBold(!is);
      component!.style.fontWeight = (is ? 'normal' : 'bold');
      moveableRef.current.updateRect();
    }

    const redo = () => doAction(selectedComponent.current!, is);
    const undo = () => doAction(selectedComponent.current!, !is);

    redo();
    history.push(undo, redo, 'Bold');
  }

  function toggleItalic() {
    const is = isComponentItalic(selectedComponent.current!);

    const doAction = (component: HTMLElement, is: boolean) => {
      setIsItalic(!is);
      component!.style.fontStyle = is ? 'normal' : 'italic';
      moveableRef.current.updateRect();
    };

    const redo = () => doAction(selectedComponent.current!, is);
    const undo = () => doAction(selectedComponent.current!, !is);

    redo();
    history.push(undo, redo, 'Italic');
  }

  function toggleUppercase() {
    const is = isComponentUppercase(selectedComponent.current!);

    const doAction = (component: HTMLElement, is: boolean) => {
      setIsUppercase(!is);
      component!.style.textTransform = is ? 'none' : 'uppercase';
      moveableRef.current.updateRect();
    };

    const redo = () => doAction(selectedComponent.current!, is);
    const undo = () => doAction(selectedComponent.current!, !is);

    redo();
    history.push(undo, redo, 'Uppercase');
  }

  function toggleTextAlign() {
    const oldTextAlign = getComponentTextAlign(selectedComponent.current!);
    const textAlign = oldTextAlign === 'left' ? 'center' : oldTextAlign === 'center' ? 'right' : 'left';

    const doAction = (component: HTMLElement, textAlign: string) => {
      const comp = component.querySelector('p')!;
      comp!.style.justifyContent = textAlign;
      comp!.style.textAlign = textAlign;
      setTextAlign(textAlign);

      moveableRef.current.updateRect();
    };

    const redo = () => doAction(selectedComponent.current!, textAlign);
    const undo = () => doAction(selectedComponent.current!, oldTextAlign);

    redo();
    history.push(undo, redo, 'Text Align');
  }

  function toggleTextVerticalAlign() {
    const oldTextVerticalAlign = getComponentTextVerticalAlign(selectedComponent.current!);
    const textVerticalAlign = oldTextVerticalAlign === 'start' ? 'center' : oldTextVerticalAlign === 'center' ? 'end' : 'start';

    const doAction = (component: HTMLElement, textVerticalAlign: string) => {
      setTextVerticalAlign(textVerticalAlign);

      const comp = component.querySelector('p')!;
      comp!.style.alignItems = textVerticalAlign;
      moveableRef.current.updateRect();
    };

    const redo = () => doAction(selectedComponent.current!, textVerticalAlign);
    const undo = () => doAction(selectedComponent.current!, oldTextVerticalAlign);

    redo();
    history.push(undo, redo, 'Text Vertical Align');
  }

  function onChangeTextAutoFit(e: RadioChangeEvent) {
    console.log(e.target.value);

    const oldValue = getComponentTextAutoFit(selectedComponent.current!);
    const newValue = e.target.value;

    const doAction = (component: any, value: string) => {
      setTextAutoFit(value);
      component!.setAttribute("auto-fit", value);
    }

    const redo = () => doAction(selectedComponent.current!, newValue);
    const undo = () => doAction(selectedComponent.current!, oldValue);

    redo();
    history.push(undo, redo, 'Text AutoFit');
  }

  function onChangeOpacity(value: number) {
    const component = selectedComponent.current!;
    const oldValue = getComponentOpacity(selectedComponent.current);
    const newValue = value;

    const doAction = (component: HTMLElement, value: number) => {
      setOpacity(value);
      component.style.opacity = `${value / 100}`;
    };

    redo = () => doAction(component, newValue);
    if (!undo) {
      undo = () => doAction(component, oldValue);
    }

    redo();
  }

  function onAfterChangeOpacity() {
    history.push(undo, redo, 'Opacity');
    undo = undefined;
    redo = undefined;
  }

  function onChangeFontFamily(value: string) {
    const component = selectedComponent.current!;
    const oldValue = getComponentFontFamily(component);

    const doAction = (component: HTMLElement, value: string) => {
      setFontFamily(value);
      component.style.fontFamily = value;
      resizeComponent(component, 'text', parseInt(window.getComputedStyle(component).width), parseInt(window.getComputedStyle(component).height), '', moveableRef);
      moveableRef.current.updateRect();
    };

    const redo = () => doAction(component, value);
    const undo = () => doAction(component, oldValue);

    redo();
    history.push(undo, redo, 'Font Family');
  }

  function onChangeFontSize(value: number | null) {
    if (value) {
      const component = selectedComponent.current!;
      const oldValue = parseFloat(component.querySelector('p')!.style.fontSize);

      const doAction = (component: HTMLElement, value: number) => {
        setFontSize(value);
        const p = component.querySelector('p')!;
        p.style.fontSize = `${value}px`;
        component.style.height = `${p.offsetHeight}px`;
        moveableRef.current.updateRect();
      };

      const redo = () => doAction(component, value);
      const undo = () => doAction(component, oldValue);

      redo();
      history.push(undo, redo, 'Font Size');
    }
  }

  function onChangeColor(color: any, value: string) {
    const component = selectedComponent.current!;
    const oldValue = component.style.color;

    const doAction = (component: HTMLElement, value: string) => {
      setColor(value);
      component.style.color = value;
    };

    const redo = () => doAction(component, value);
    const undo = () => doAction(component, oldValue);

    redo();
    history.push(undo, redo, 'Color');
  }

  function onChangeBackgroundColor(color: any, value: string) {
    const component = isText(selectedComponent.current!) ? selectedComponent.current!.querySelector('p')! : selectedComponent.current!;
    const oldValue = component.style.backgroundColor;

    const doAction = (component: HTMLElement, value: string) => {
      setBackgroundColor(value);
      component.style.backgroundColor = value;
    };

    const redo = () => doAction(component, value);
    const undo = () => doAction(component, oldValue);

    redo();
    history.push(undo, redo, 'Background Color');
  }

  function onChangePadding(value: number) {
    const component = isText(selectedComponent.current!) ? selectedComponent.current!.querySelector('p')! : selectedComponent.current!;
    const oldValue = parseFloat(component!.style.padding);

    const doAction = (component: HTMLElement, value: number) => {
      const comp = isText(component) ? component.querySelector('p')! : selectedComponent.current!;
      setPadding(value);
      comp!.style.padding = `${value}px`;

      if (isText(component)) {
        resizeComponent(component, 'text', parseInt(window.getComputedStyle(comp).width), parseInt(window.getComputedStyle(comp).height), '', moveableRef);
      }

      moveableRef.current.updateRect();
    };

    const redo = () => doAction(selectedComponent.current!, value);
    const undo = () => doAction(selectedComponent.current!, oldValue);

    redo();
    moveableRef.current.updateRect();
    history.push(undo, redo, 'Padding');
  }

  function onChangeBorderColor(color: any, value: string) {
    const component = isText(selectedComponent.current!) ? selectedComponent.current!.querySelector('p')! : selectedComponent.current!;
    const oldValue = component!.style.borderColor;

    const doAction = (component: HTMLElement, value: string) => {
      setBorderColor(value);
      component!.style.borderColor = value;
    };

    const redo = () => doAction(component, value);
    const undo = () => doAction(component, oldValue);

    redo();
    history.push(undo, redo, 'Border Color');
  }

  function onChangeBorderWidth(value: number) {
    const component = isText(selectedComponent.current!) ? selectedComponent.current!.querySelector('p')! : selectedComponent.current!;
    const oldValue = parseFloat(component!.style.borderWidth);

    const doAction = (component: HTMLElement, value: number) => {
      setBorderWidth(value);
      component!.style.borderWidth = `${value}px`;
      moveableRef.current.updateRect();
    };

    const redo = () => doAction(component, value);
    const undo = () => doAction(component, oldValue);

    redo();
    history.push(undo, redo, 'Border Width');
  }

  function onChangeBorderRadius(value: number) {
    const component = isText(selectedComponent.current!) ? selectedComponent.current!.querySelector('p')! : selectedComponent.current!;
    const oldValue = parseFloat(component!.style.borderRadius);

    const doAction = (component: HTMLElement, value: number) => {
      setBorderRadius(value);
      component!.style.borderRadius = `${value}px`;
      moveableRef.current.updateRect();
    };

    const redo = () => doAction(component, value);
    const undo = () => doAction(component, oldValue);

    redo();
    history.push(undo, redo, 'Border Radius');
  }

  function onChangeLetterSpacing(value: number) {
    const component = selectedComponent.current!.querySelector('p')!
    const oldValue = parseFloat(component!.style.letterSpacing);

    const doAction = (component: HTMLElement, value: number) => {
      const comp = component.querySelector('p')!;
      setLetterSpacing(value);
      comp!.style.letterSpacing = `${value}px`;

      resizeComponent(component, 'text', parseInt(window.getComputedStyle(comp).width), parseInt(window.getComputedStyle(comp).height), '', moveableRef);

      moveableRef.current.updateRect();
    };

    const redo = () => doAction(selectedComponent.current!, value);
    const undo = () => doAction(selectedComponent.current!, oldValue);

    redo();
    moveableRef.current.updateRect();
    history.push(undo, redo, 'Letter Spacing');
  }

  function onChangeLineHeight(value: number) {
    const component = selectedComponent.current!.querySelector('p')!
    const oldValue = parseFloat(component!.style.lineHeight);

    const doAction = (component: HTMLElement, value: number) => {
      const comp = component.querySelector('p')!;
      setLineHeight(value);
      comp!.style.lineHeight = `${value}em`;

      resizeComponent(component, 'text', parseInt(window.getComputedStyle(comp).width), parseInt(window.getComputedStyle(comp).height), '', moveableRef);

      moveableRef.current.updateRect();
    };

    const redo = () => doAction(selectedComponent.current!, value);
    const undo = () => doAction(selectedComponent.current!, oldValue);

    redo();
    moveableRef.current.updateRect();
    history.push(undo, redo, 'Line Height');
  }

  function onChangeShapeLineColor(color: any, value: string) {
    const component = selectedComponent.current!;
    const oldValue = component.querySelector('svg')!.firstElementChild!.getAttribute('stroke')!;

    const doAction = (component: HTMLElement, value: string) => {
      setShapeLineColor(value);
      component.querySelector('svg')!.firstElementChild!.setAttribute('stroke', value);
    };

    const redo = () => doAction(component, value);
    const undo = () => doAction(component, oldValue);

    redo();
    history.push(undo, redo, 'Shape Line Color');
  }

  function onChangeShapeFillColor(color: any, value: string) {
    const component = selectedComponent.current!;
    const oldValue = component.querySelector('svg')!.firstElementChild!.getAttribute('fill')!;

    const doAction = (component: HTMLElement, value: string) => {
      setShapeFillColor(value);
      component.querySelector('svg')!.firstElementChild!.setAttribute('fill', value);
    };

    const redo = () => doAction(component, value);
    const undo = () => doAction(component, oldValue);

    redo();
    history.push(undo, redo, 'Shape Fill Color');
  }

  function onChangeShapeLineWidth(value: number) {
    const component = selectedComponent.current!;
    const oldValue = parseInt(component.querySelector('svg')!.firstElementChild!.getAttribute('stroke-width')!);

    const doAction = (component: HTMLElement, value: number) => {
      setShapeLineWidth(value);
      const svg = component.querySelector('svg')!
      svg.firstElementChild!.setAttribute('stroke-width', value.toString());
      moveableRef.current.updateRect();
    };

    const redo = () => doAction(component, value);
    const undo = () => doAction(component, oldValue);

    redo();
    history.push(undo, redo, 'Shape Line Width');
  }

  function onChangeShapeLineRadius(value: number) {
    const component = selectedComponent.current!;
    const oldValue = parseInt(component.querySelector('svg')!.firstElementChild!.getAttribute('rx')!);

    const doAction = (component: HTMLElement, value: number) => {
      setShapeLineRadius(value);
      component.querySelector('svg')!.firstElementChild!.setAttribute('rx', value.toString());
      moveableRef.current.updateRect();
    };

    const redo = () => doAction(component, value);
    const undo = () => doAction(component, oldValue);

    redo();
    history.push(undo, redo, 'Shape Line Radius');
  }

  function toForward() {
    const canvas = document.getElementById("canvas")!;
    const next = selectedComponent.current!.nextElementSibling

    if (next != null) {
      next.after(selectedComponent.current!);
    } else {
      canvas.append(selectedComponent.current!);
    }
  }

  function toBackward() {
    const prev = selectedComponent.current!.previousElementSibling;

    if (prev != null) {
      prev.before(selectedComponent.current!);
    }
  }

  function toFront() {
    const canvas = document.getElementById("canvas")!;
    canvas.append(selectedComponent.current!);
  }

  function toBack() {
    const canvas = document.getElementById("canvas")!;
    canvas.prepend(selectedComponent.current!);
  }

  function onChangeZoom(value: number) {
    if (value < 10 || value > 100) return;
    updateZoom(value);
    setZoom(value);
    deselect();
  }

  function move(direction: string) {
    if (selectedComponent.current) {
      const currentTransform = selectedComponent.current.style.transform || '';

      const translateRegex = /translate\(([^,]+)px, ([^)]+)px\)/;
      const matches = currentTransform.match(translateRegex);

      const distance = 2;
      let x = 0;
      let y = 0;
      let oldX = 0;
      let oldY = 0;

      if (matches) {
        x = parseFloat(matches[1]);
        y = parseFloat(matches[2]);
        oldX = parseFloat(matches[1]);
        oldY = parseFloat(matches[2]);
      }

      switch (direction) {
        case 'up':
          y -= distance;
          break;
        case 'down':
          y += distance;
          break;
        case 'left':
          x -= distance;
          break;
        case 'right':
          x += distance;
          break;
        default:
          return;
      }

      const doAction = (component: HTMLElement, x: number, y: number) => {
        const updatedTransform = `translate(${x}px, ${y}px)`;
        component.style.transform = currentTransform.replace(translateRegex, updatedTransform);
        moveableRef.current.updateRect();
      }

      const redo = () => doAction(selectedComponent.current!, x, y);
      const undo = () => doAction(selectedComponent.current!, oldX, oldY);

      redo();
      history.push(undo, redo, 'Move');
    }
  }

  function getElementGuidelines() {
    const guidelines = [];

    Array.from(document.querySelectorAll('.component')).forEach(function (el) {
      guidelines.push({
        element: el,
        className: 'guideline-to-element-' + el.getAttribute('id')
      });
    });

    guidelines.push({
      element: document.querySelector("#canvas"),
      className: 'guideline-to-page'
    });
    return guidelines;
  }

  function goToDashboard() {
    if (demo) {
      messageApi.open({
        type: 'success',
        content: DEMO_MESSAGE,
      });
      return;
    }

    setLoading(true);

    save(() => navigate('/'));
  }

  function selectTemplate(template: TemplateDto) {
    setLoading(true);
    save(() => {
      TemplateApi.createFromMaster(template.id!!, user.id!!).then(resp => {
        if (resp.data) {
          window.location.href = `/editor/${resp.data.id}`;
        }
      });
    });
  }

  return <>
    {
      loading ? (
        <>
          {/* <RainbowHeader /> */}
          <div className={"app-loading"}>
            <Space direction="vertical" style={{ alignItems: 'center', textAlign: 'center' }}>
              {/* <div>
                <LogoIcon size="large" />
                <i>Let's get templated!</i>
              </div>

              <img src="/images/loading-thumbnail.gif" height={200} /> */}

              <LoaderBlocks />
            </Space>
          </div>
        </>
      ) : (
        <>
          {isMobile &&
            <div className="fixed inset-0 bg-black bg-opacity-90 flex flex-col items-center justify-center text-center text-white z-50 px-4 gap-2">
              <p className="leading-6 text-lg">We're sorry, but the Templated Editor is not optimized for mobile devices.</p>
              <p className="leading-6 text-lg">Please use a desktop for the best experience.</p>
              <Button type="primary" className="m-4" onClick={goToDashboard}>Go back to Home</Button>
            </div>
          }

          <Layout className="editor-page">
            <Helmet>
              <title>{template?.name + " | Templated"}</title>
              <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            {/* <RainbowHeader /> */}
            {contextHolder}

            <Header className="main">
              <Space>
                <Space size={"small"} onClick={goToDashboard}>
                  <Tooltip title="Go back to Home" placement="bottomLeft">
                    <div className="flex items-center">
                      <a><IconChevronLeft width={30} height={30} stroke={3} className="text-gray-600" /></a>
                      <LogoIcon link={false} />
                    </div>
                  </Tooltip>
                </Space>

                <Dropdown trigger={["click"]} dropdownRender={() => (
                  <Card className="file-dropdown" size="small">
                    <Flex vertical justify="space-between" gap={10}>
                      <p className="font-bold">{template.name}</p>
                      <p className="font-bold text-sm">ID: <span className="font-mono bg-slate-100 py-2 px-2 rounded">{template.id}</span></p>
                      <p className="text-slate-500 text-sm">{template.width}px x {template.height}px</p>
                      <Button type="dashed" className="text-left w-fit" onClick={downloadTemplate} loading={downloading}>Download Sample</Button>

                      {/* {user.isAdmin &&
                        <>
                          <TextArea className="ghost" rows={4} onChange={onChangeTemplateDescription} defaultValue={template?.description ?? ""} placeholder="Insert your template description" />
                          <Space.Compact>
                          <Select>
                            {categories.map(cat => {
                              return (<Option value={cat.id}>{cat.name}</Option>)
                            })}
                          </Select>
                          <Button icon={<PlusIcon />}></Button>
                        </Space.Compact>
                        </>
                      } */}
                      {/* <Input className="ghost" onChange={onChangeTemplateCategory} defaultValue={template?.category ?? ""} /> */}
                      {/* <Input className="ghost" onChange={onChangeTemplateTags} defaultValue={template?.tags ?? ""} /> */}
                      {/* <Button type="primary" className="save-btn" onClick={() => save()} loading={saving}>{saving ? 'Saving' : 'Save'}</Button> */}
                    </Flex>
                  </Card>
                )}>
                  <Button type="text">
                    File
                  </Button>
                </Dropdown>

                <Dropdown trigger={["click"]} dropdownRender={() => (
                  <Card size="small" style={{ width: 210 }}>
                    <InputNumber size="large" controls={false} addonBefore="Width" addonAfter="px" min={1} max={2000} onChange={onChangeTemplateWidth} defaultValue={template?.width} className="mb-3" />
                    <InputNumber size="large" controls={false} addonBefore="Height" addonAfter="px" min={1} max={2000} onChange={onChangeTemplateHeight} defaultValue={template?.height} />
                  </Card>
                )}>
                  <Button type="text">
                    Resize
                  </Button>
                </Dropdown>

                <span contentEditable="true" spellCheck={false} className="flex items-center justify-center h-8 px-2 tracking-normal border border-gray-700 hover:border-gray-500 rounded" onInput={debounce(onChangeTemplateName, 1500)}>{template.name}</span>
              </Space>

              <div className="flex justify-between gap-2">
                <div className="flex justify-between gap-2">
                  <Tooltip title="Undo">
                    <Button type="text" ghost icon={<Undo2 />} onClick={history.undo} disabled={history.history.length === 0} />
                  </Tooltip>
                  <Tooltip title="Redo">
                    <Button type="text" ghost icon={<Redo2 />} onClick={history.redo} disabled={history.history.length === 0} />
                  </Tooltip>
                </div>

                <Tooltip title="Download">
                  <Button type="text" ghost icon={<IconCloudDownload />} onClick={downloadTemplate} loading={downloading}></Button>
                </Tooltip>

                <Button type="primary" className="save-btn" onClick={() => save()} loading={saving}>{saving ? 'Saving' : 'Save'}</Button>
              </div>
            </Header>

            <Layout>
              <Sider className="sidebar sidebar-left-tabs text-center" width={85}>
                <a href="#" className={activeSidebarTab === 'templates-gallery' ? 'active' : ''} onClick={() => selectSidebar('templates-gallery')}>
                  <IconKeyframes />
                  Templates
                </a>
                <a href="#" className={activeSidebarTab === 'text' ? 'active' : ''} onClick={() => selectSidebar('text')}>
                  <Type />
                  Text
                </a>
                <a href="#" className={activeSidebarTab === 'images' ? 'active' : ''} onClick={() => selectSidebar('images')}>
                  <ImageIcon />
                  Images
                </a>
                <a href="#" className={activeSidebarTab === 'shapes' ? 'active' : ''} onClick={() => selectSidebar('shapes')}>
                  <IconTriangleSquareCircle stroke={1.5} style={{ width: 30, height: 30 }} />
                  Shapes
                </a>
                <a href="#" className={activeSidebarTab === 'uploads' ? 'active' : ''} onClick={() => selectSidebar('uploads')}>
                  <IconCloudUpload stroke={1.5} style={{ width: 30, height: 30 }} />
                  Uploads
                </a>
              </Sider>

              <Sider className="sidebar sidebar-left" width={340}>
                {activeSidebarTab === 'templates-gallery' &&
                  <AsideTemplatesGallery selectTemplate={selectTemplate} />
                }

                {activeSidebarTab === 'text' &&
                  <Flex gap="small" vertical>
                    <h4>Default text styles</h4>

                    <div className="component-template text" onClick={(ev) => addComponent(ev, 'text')}>
                      <p style={{ fontSize: 32, lineHeight: 1.4 }}>Add a heading</p>
                    </div>

                    <div className="component-template text" onClick={(ev) => addComponent(ev, 'text')}>
                      <p style={{ fontSize: 20, lineHeight: 1.4 }}>Add a subheading</p>
                    </div>

                    <div className="component-template text" onClick={(ev) => addComponent(ev, 'text')}>
                      <p style={{ fontSize: 16, lineHeight: 1.4 }}>Add body text</p>
                    </div>
                  </Flex>
                }

                {activeSidebarTab === 'images' &&
                  <AsideImages addComponent={addComponent} />
                }

                {activeSidebarTab === 'shapes' &&
                  <Space direction="vertical" style={{ width: '100%' }}>
                    <h4>Shapes</h4>

                    <Masonry gutter="10px">
                      {/* Filled Square */}
                      <div className="component-template shape" onClick={(ev) => addComponent(ev, 'shape')}>
                        <svg width="100" height="100" viewBox="0 0 100 100">
                          <rect fill="#fff" stroke="#fff" strokeWidth="5" x="0" y="0"
                            width="100" height="100" fillOpacity="1" strokeOpacity="1"></rect>
                        </svg>
                      </div>

                      {/* Filled Circle */}
                      <div className="component-template shape" onClick={(ev) => addComponent(ev, 'shape')}>
                        <svg width="100" height="100" viewBox="0 0 100 100">
                          <ellipse fill="#fff" stroke="#fff" strokeWidth="5" cx="50" cy="50" rx="45" ry="45"></ellipse>
                        </svg>
                      </div>

                      {/* Filled Triangle */}
                      <div className="component-template shape" onClick={(ev) => addComponent(ev, 'shape')}>
                        <svg width="100" height="100" viewBox="0 0 100 100">
                          <polygon fill="#fff" stroke="#fff" strokeWidth="5" points="50 5, 95 95, 5 95" />
                        </svg>
                      </div>

                      {/* Bordered Square */}
                      <div className="component-template shape" onClick={(ev) => addComponent(ev, 'shape')}>
                        <svg width="100" height="100" viewBox="0 0 100 100">
                          <rect fill="none" stroke="#fff" strokeWidth="5" x="0" y="0"
                            width="100" height="100" fillOpacity="1" strokeOpacity="1"></rect>
                        </svg>
                      </div>


                      {/* Bordered Circle */}
                      <div className="component-template shape" onClick={(ev) => addComponent(ev, 'shape')}>
                        <svg width="100" height="100" viewBox="0 0 100 100">
                          <ellipse fill="none" stroke="#fff" strokeWidth="5" cx="50" cy="50" rx="45" ry="45"></ellipse>
                        </svg>
                      </div>

                      {/* Filled Borderedriangle */}
                      <div className="component-template shape" onClick={(ev) => addComponent(ev, 'shape')}>
                        <svg width="100" height="100" viewBox="0 0 100 100">
                          <polygon fill="none" stroke="#fff" strokeWidth="5" points="50 5, 95 95, 5 95" />
                        </svg>
                      </div>

                      <div className="component-template shape line" onClick={(ev) => addComponent(ev, 'shape')}>
                        <svg viewBox="0 100 100 5" style={{ width: 100, height: "auto" }}>
                          <line fill="none" stroke="#fff" strokeWidth="5" x1="0" y1="100" x2="100" y2="100"></line>
                        </svg>
                      </div>

                      {/* <div className="component-template shape" onClick={(ev) => addComponent(ev, 'shape')}>
                      <svg width="100" height="100" viewBox="0 0 100 100">
                        <line fill="none" stroke="#fff" strokeWidth="5" x1="95" y1="5" x2="95" y2="95"></line>
                      </svg>
                    </div> */}



                    </Masonry>

                  </Space>
                }

                {activeSidebarTab === 'uploads' &&
                  <AsideUploads addComponent={addComponent} />
                }
              </Sider>

              <Layout style={{ position: 'relative' }}>
                {selectedComponent.current &&
                  <div className="toolbar">
                    <Space>
                      {isCanvas(selectedComponent.current) &&
                        <ColorPicker disabledAlpha onChange={onChangeBackgroundColor} value={backgroundColor} />
                      }

                      {isText(selectedComponent.current) &&
                        <>
                          <Select style={{ width: 180, fontFamily: fontFamily }}
                            value={fontFamily}
                            popupMatchSelectWidth={false}
                            listHeight={700}
                            showSearch
                            filterOption={(input: string, option?: { label: string; value: string }) =>
                              (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
                            open={fontSelectOpen}
                            onBlur={() => { setFontSelectOpen(false); }}
                            onClick={() => { setFontSelectOpen(true); }}
                            onChange={onChangeFontFamily}>
                            {fonts.map(font => {
                              return (<Option value={font} style={{ fontFamily: font, fontSize: 20 }}>{font}</Option>)
                            })}
                          </Select>

                          <InputNumber<number>
                            className="font-size-input"
                            addonBefore={<Button type="text" onClick={() => onChangeFontSize(fontSize - 1)}><Minus size={15} /></Button>}
                            addonAfter={<Button type="text" onClick={() => onChangeFontSize(fontSize + 1)}><Plus size={15} /></Button>}
                            onChange={onChangeFontSize}
                            controls={false}
                            value={fontSize}
                            style={{ width: 105 }}
                          />

                          <Tooltip title="Text Color" placement="bottom">
                            <Button type="text">
                              <ColorPicker disabledAlpha onChange={onChangeColor} value={color} />
                            </Button>
                          </Tooltip>

                          <Button type="text" onClick={toggleBold} className={isBold ? 'active' : ''}>
                            <Tooltip title="Bold" placement="bottom">
                              <Bold />
                            </Tooltip>
                          </Button>

                          <Button type="text" onClick={toggleItalic} className={isItalic ? 'active' : ''}>
                            <Tooltip title="Italic" placement="bottom">
                              <Italic />
                            </Tooltip>
                          </Button>

                          <Button type="text" onClick={toggleUppercase} className={isUppercase ? 'active' : ''}>
                            <Tooltip title="Uppercase" placement="bottom">
                              <CaseSensitive />
                            </Tooltip>
                          </Button>

                          <Divider type="vertical" />

                          <Button type="text" onClick={toggleTextAlign}>
                            <Tooltip title="Alignment" placement="bottom">
                              {textAlign === 'left' && <AlignLeft />}
                              {textAlign === 'center' && <AlignCenter />}
                              {textAlign === 'right' && <AlignRight />}
                            </Tooltip>
                          </Button>

                          <Button type="text" onClick={toggleTextVerticalAlign}>
                            <Tooltip title="Vertical Alignment" placement="bottom">
                              {textVerticalAlign === 'start' && <IconAlignBoxCenterTop />}
                              {textVerticalAlign === 'center' && <IconAlignBoxCenterMiddle />}
                              {textVerticalAlign === 'end' && <IconAlignBoxCenterBottom />}
                            </Tooltip>
                          </Button>

                          <Dropdown trigger={["click"]}
                            dropdownRender={() => (
                              <Card size="small" style={{ width: 220 }}>
                                <Space direction="vertical" size="small">
                                  <div>
                                    Letter spacing
                                    <Slider style={{ width: 185, marginBottom: 5 }} min={-10} max={20} marks={{ 0: ' ' }} value={letterSpacing} onChange={onChangeLetterSpacing} />
                                  </div>

                                  <div>
                                    Line spacing
                                    <Slider style={{ width: 185, marginBottom: 5 }} min={0.5} max={2.5} step={0.01} marks={{ 1.4: ' ' }} value={lineHeight} onChange={onChangeLineHeight} />
                                  </div>
                                </Space>
                              </Card>
                            )}>
                            <Button type="text">
                              <Tooltip title="Spacing" placement="bottom">
                                <IconLineHeight />
                              </Tooltip>
                            </Button>
                          </Dropdown>

                          <Divider type="vertical" />

                          <Dropdown trigger={["click"]}
                            dropdownRender={() => (
                              <Card size="small" style={{ width: 220 }}>
                                <Flex vertical>
                                  <Flex justify="space-between" align="center">
                                    Color
                                    <ColorPicker onChange={onChangeBackgroundColor} value={backgroundColor} />
                                  </Flex>

                                  <Flex justify="space-between" align="center">
                                    Padding
                                    <Slider style={{ width: 120 }} min={0} max={50} value={padding} onChange={onChangePadding} />
                                  </Flex>

                                  <Flex justify="space-between" align="center">
                                    Round
                                    <Slider style={{ width: 120 }} min={0} max={500} value={borderRadius} onChange={onChangeBorderRadius} />
                                  </Flex>
                                </Flex>
                              </Card>
                            )}>
                            <Button type="text" style={{ backgroundColor: backgroundColor }}>
                              <Tooltip title="Fill" placement="bottom">
                                <PaintBucket />
                              </Tooltip>
                            </Button>
                          </Dropdown>

                        </>
                      }

                      {(isText(selectedComponent.current) || isImage(selectedComponent.current)) &&
                        <Dropdown trigger={["click"]}
                          dropdownRender={() => (
                            <Card size="small" style={{ width: 220 }}>
                              <Flex vertical>
                                <Flex justify="space-between" align="center">
                                  Color
                                  <ColorPicker onChange={onChangeBorderColor} value={borderColor || "#ffffff"} />
                                </Flex>

                                <Flex justify="space-between" align="center">
                                  Width
                                  <Slider style={{ width: 120 }} min={0} max={50} value={borderWidth} onChange={onChangeBorderWidth} />
                                </Flex>

                                <Flex justify="space-between" align="center">
                                  Round
                                  <Slider style={{ width: 120 }} min={0} max={500} value={borderRadius} onChange={onChangeBorderRadius} />
                                </Flex>
                              </Flex>
                            </Card>
                          )}>
                          <Button type="text">
                            <Tooltip title="Border" placement="bottom">
                              <BoxSelect />
                            </Tooltip>
                          </Button>
                        </Dropdown>
                      }

                      {isShape(selectedComponent.current) &&
                        <>
                          <ColorPicker disabledAlpha value={shapeLineColor} onChange={onChangeShapeLineColor} showText={(color) => <span>Line</span>} />
                          <ColorPicker disabledAlpha value={shapeFillColor} onChange={onChangeShapeFillColor} showText={(color) => <span>Fill</span>} />

                          <Dropdown trigger={["click"]}
                            dropdownRender={() => (
                              <Card size="small" style={{ width: 220 }}>
                                <Flex vertical>
                                  <Flex justify="space-between" align="center">
                                    Width
                                    <Slider style={{ width: 120 }} min={0} max={50} value={shapeLineWidth} onChange={onChangeShapeLineWidth} />
                                  </Flex>

                                  <Flex justify="space-between" align="center">
                                    Round
                                    <Slider style={{ width: 120 }} min={0} max={500} value={shapeLineRadius} onChange={onChangeShapeLineRadius} />
                                  </Flex>
                                </Flex>
                              </Card>
                            )}>
                            <Button type="text">
                              <Tooltip title="Border" placement="bottom">
                                <BoxSelect />
                              </Tooltip>
                            </Button>
                          </Dropdown>

                          {/* <Button>Weight</Button>
                  <Button>Radius</Button> */}
                        </>
                      }

                      {(isText(selectedComponent.current) || isImage(selectedComponent.current) || isShape(selectedComponent.current)) &&
                        <Dropdown trigger={["click"]}
                          dropdownRender={() => (
                            <Card size="small" title="Transparency" style={{ width: 150 }}>
                              <Slider value={opacity} onChange={onChangeOpacity} onAfterChange={onAfterChangeOpacity} />
                            </Card>
                          )}>
                          <Button type="text">
                            <Tooltip title="Transparency" placement="bottom">
                              <Sun />
                            </Tooltip>
                          </Button>
                        </Dropdown>
                      }
                    </Space>

                    {!isCanvas(selectedComponent.current) &&
                      <Space>
                        {isText(selectedComponent.current) &&
                          <Dropdown trigger={["click"]} placement="bottom"
                            dropdownRender={() => (
                              <Card size="small">
                                <Radio.Group buttonStyle="solid" onChange={onChangeTextAutoFit} defaultValue={""} value={textAutoFit}>
                                  <Space size={"small"} direction="vertical">
                                    <Radio.Button value="" checked><Space size="small"><IconMaximizeOff />OFF</Space></Radio.Button>
                                    <Radio.Button value="width"><Space size="small"><IconArrowAutofitWidth /> Fill Width</Space></Radio.Button>
                                    <Radio.Button value="height"><Space size="small"><IconArrowAutofitHeight /> Fill Height</Space></Radio.Button>
                                  </Space>
                                </Radio.Group>
                              </Card>
                            )}>
                            <Button type="text">
                              <Tooltip title={<><b className="font-mono">[AUTOFIT]</b> will make the text fill the width or height of the component</>} placement="left">
                                <b className="font-mono select-none">[AUTOFIT]</b>
                              </Tooltip>
                            </Button>
                          </Dropdown>

                          // <>
                          //   <Tooltip title={<><b className="font-mono">[AUTOFIT]</b> will make the text fill the height of the component</>} placement="bottom">
                          //     <Space>
                          //       <b className="font-mono select-none">[AUTOFIT]</b>
                          //       <Switch size="small" checked={isTextAutoFit} onChange={toggleTextAutoFit} />
                          //     </Space>
                          //   </Tooltip>
                          //   <Divider type="vertical" />
                          // </>
                        }

                        <Dropdown trigger={["click"]} placement="bottomRight"
                          dropdownRender={() => (
                            <Card size="small" className="position-dropdown" style={{ width: 270 }}>
                              <Row justify={"space-between"}>
                                <Col span={12}>
                                  <Button block type="text" onClick={toForward}>
                                    <Flex align="space-between">
                                      <ArrowUpNarrowWide /> Forward
                                    </Flex>
                                  </Button>
                                </Col>
                                <Col span={12}>
                                  <Button block type="text" onClick={toBackward}>
                                    <Flex align="space-between">
                                      <ArrowDownNarrowWide /> Backward
                                    </Flex>
                                  </Button>
                                </Col>
                              </Row>

                              <Row justify={"space-between"}>
                                <Col span={12}>
                                  <Button block type="text" onClick={toFront}>
                                    <Flex align="sp">
                                      <ArrowUpToLine /> To front
                                    </Flex>
                                  </Button>
                                </Col>
                                <Col span={12}>
                                  <Button block type="text" onClick={toBack}>
                                    <Flex align="sp">
                                      <ArrowDownToLine /> To back
                                    </Flex>
                                  </Button>
                                </Col>
                              </Row>
                            </Card>
                          )}>
                          <Button type="text">
                            <Tooltip title="Position" placement="bottom">
                              <IconArrowsUpDown />
                            </Tooltip>
                          </Button>
                        </Dropdown>

                        <Button type="text" onClick={toggleLocked}>
                          <Tooltip title={<div className="text-center">{isLocked ? "Unlock" : "Lock"} <br /><span className="text-xs">Locked layers can't be updated</span></div>} placement="bottom">
                            {isLocked && <IconLock className="text-rose-600" />}
                            {!isLocked && <IconLockOpen />}
                          </Tooltip>
                        </Button>

                        <Button type="text" onClick={() => deleteComponent()}>
                          <Tooltip title="Delete" placement="bottom">
                            <IconTrash />
                          </Tooltip>
                        </Button>
                      </Space>
                    }
                  </div>

                }

                {template &&
                  <Content className="content" ref={containerRef}>
                    {parse(html)}

                    <div className="bottom-actions">
                      <Flex gap={"small"} align="center">
                        <Button type="text" icon={<ZoomOut onClick={() => onChangeZoom(zoom - 10)} />} />
                        <Slider min={10} max={100} style={{ width: 200 }} onChange={onChangeZoom} value={zoom} />
                        <Button type="text" icon={<ZoomIn onClick={() => onChangeZoom(zoom + 10)} />} />
                      </Flex>
                    </div>

                    <Moveable target={targetRef.current} container={containerRef.current}
                      ref={moveableRef}
                      flushSync={flushSync}
                      draggable={true}
                      // throttleDrag={1}
                      edgeDraggable={false}
                      // startDragRotate={0}
                      // throttleDragRotate={1}
                      resizable={true}
                      // scalable={type === "shape"}
                      keepRatio={keepRatio}
                      // keepRatioFinally={true}
                      throttleResize={1}
                      // throttleScale={0}
                      renderDirections={renderDirections}
                      rotatable={true}
                      throttleRotate={1}
                      origin={false}
                      // rotationPosition={"top"}
                      // originDraggable={true}
                      // originRelative={true}
                      ables={[DimensionViewable]}
                      props={{ dimensionViewable: showDimensionViewable }}
                      snappable={true}
                      snapContainer={document.querySelector("#canvas") as any}
                      snapDirections={{ "top": true, "left": true, "bottom": true, "right": true, "center": true, "middle": true }}
                      elementSnapDirections={{ "top": true, "left": true, "bottom": true, "right": true, "center": true, "middle": true }}
                      snapThreshold={6}
                      snapGap={false}
                      snapDigit={20}
                      // isDisplaySnapDigit={true}
                      // isDisplayInnerSnapDigit={true}
                      snapDistFormat={(v, type) => `${v}px`}
                      elementGuidelines={getElementGuidelines()}
                      // verticalGuidelines={getVerticalGuidelines()}
                      // horizontalGuidelines={getHorizontalGuidelines()}
                      // onDragOrigin={e => {
                      //   e.target.style.transformOrigin = e.transformOrigin;
                      // }}
                      // onRender={e => {
                      //   e.target.style.transform = e.transform;
                      // }}

                      // DRAG
                      onDragStart={e => {
                        const oldTransform = e.target.style.transform;
                        undo = () => dragComponent(e.target!, oldTransform, moveableRef);
                      }}
                      onDrag={e => {
                        redo = () => dragComponent(e.target!, e.transform, moveableRef);
                        redo();
                      }}
                      onDragEnd={e => {
                        history.push(undo, redo, 'Drag');
                      }}

                      // RESIZE
                      onResizeStart={e => {
                        const handleDirection = e.inputEvent.target.attributes["data-direction"].value;
                        const isCornerHandle = ['sw', 'se', 'nw', 'ne'].includes(handleDirection);
                        setKeepRatio(isCornerHandle);
                        setShowDimensionViewable(true);

                        const oldWidth = parseInt(e.target.style.width);
                        const oldHeight = parseInt(e.target.style.height);
                        const oldTransform = e.target.style.transform;
                        undo = () => resizeComponent(e.target!, type, oldWidth, oldHeight, oldTransform, moveableRef);
                      }}
                      onResize={e => {
                        redo = () => resizeComponent(e.target!, type, e.width, e.height, e.drag.transform, moveableRef);
                        redo();
                      }}
                      onResizeEnd={e => {
                        history.push(undo, redo, 'Resize');
                        setShowDimensionViewable(false);
                      }}

                      // // SCALE
                      // onScaleStart={e => {
                      //   const handleDirection = e.inputEvent.target.attributes["data-direction"].value;
                      //   const isCornerHandle = ['sw', 'se', 'nw', 'ne'].includes(handleDirection);
                      //   setKeepRatio(isCornerHandle);
                      //   setShowDimensionViewable(true);

                      //   const oldTransform = e.target.style.transform;
                      //   undo = () => scaleComponent(e.target!, oldTransform, moveableRef);
                      // }}
                      // onScale={e => {
                      //   redo = () => scaleComponent(e.target!, e.transform, moveableRef);
                      //   redo();
                      // }}
                      // onScaleEnd={e => {
                      //   history.push(undo, redo, 'Drag');
                      //   setShowDimensionViewable(false);
                      // }}

                      // ROTATE
                      onRotateStart={e => {
                        const oldTransform = e.target.style.transform;
                        undo = () => rotateComponent(e.target!, oldTransform, moveableRef);
                      }}
                      onRotate={e => {
                        redo = () => rotateComponent(e.target!, e.transform, moveableRef);
                        redo();
                      }}
                      onRotateEnd={e => {
                        history.push(undo, redo, 'Drag');
                      }}

                      onChangeTargets={e => {
                        // console.log(e)
                        // if (e.targets && e.targets[0]) moveableRef.current.dragStart(e.targets[0]);
                      }}

                    />
                  </Content>
                }
              </Layout>

              <Sider className="sidebar sidebar-right" width={200}>
                <Flex gap="small" vertical>
                  <Tooltip title={<div className="text-center">Layers are the components that you can update using the API</div>} placement="bottom">
                    <p className="text-lg font-bold flex items-center justify-center my-2"><IconStack2 className="mr-1" /> Layers</p>
                  </Tooltip>

                  <Flex gap="small" vertical className="layers">
                    {components && Array.from(components).reverse().map(component => {
                      return (
                        <Button block className={`secondary layer text-center !px-2 ${component == selectedComponent.current ? '!bg-primary text-white' : ''} ${isComponentLocked(component) ? ' border-rose-600 border-2 !text-rose-600' : ''} layer-${component.id}`}
                          onDrag={() => select(component)}
                          onClick={() => select(component)}>
                          <Flex align="center" justify="space-between" style={{ height: "100%" }}>

                            {isText(component) && <Tooltip title="Text layer"><Type /></Tooltip>}
                            {isImage(component) && <Tooltip title="Image layer"><ImageIcon /></Tooltip>}
                            {isShape(component) && <Tooltip title="Shape layer"><IconTriangleSquareCircle stroke={1.8} style={{ width: 26, height: 26 }} /></Tooltip>}

                            <span className="layer-name">
                              {component.getAttribute('name')}
                            </span>

                            {isComponentLocked(component)
                              ? <IconLock className="text-rose-600" />
                              : <Dropdown
                                overlayClassName="template-actions"
                                trigger={["click"]}
                                // placement="topRight"
                                menu={{
                                  items: [
                                    {
                                      key: '1',
                                      label: (
                                        <Popconfirm
                                          placement="left"
                                          arrow={false}
                                          title="Rename layer"
                                          icon={false}
                                          description={<><input id={`rename-component-input-${component.id}`} type="text" placeholder={component.getAttribute('name')!} /></>}
                                          onConfirm={() => renameComponent(component)}
                                          okText="Rename"
                                          cancelText="Cancel">
                                          <Flex align="center" gap={8}>
                                            <TextCursorInput />
                                            Rename
                                          </Flex>
                                        </Popconfirm>

                                        // <Dropdown
                                        //   overlayClassName="rename-actions"
                                        //   trigger={["click"]}
                                        //   placement="topRight"
                                        //   menu={{
                                        //     items: [
                                        //       {
                                        //         key: '1',
                                        //         label: (
                                        //           <input type="text" value={component.getAttribute('name')!} />
                                        //         )
                                        //       }
                                        //     ]
                                        //   }}>
                                        //   {/* <Flex align="center" gap={8} onClick={(ev) => renameComponent(component, ev)}> */}
                                        //   <Flex align="center" gap={8}>
                                        //     <TextCursorInput />
                                        //     Rename
                                        //   </Flex>
                                        // </Dropdown>
                                      ),
                                    },
                                    {
                                      key: '2',
                                      label: (
                                        <Flex align="center" gap={8} onClick={() => duplicateComponent(component)}>
                                          <Copy />
                                          Duplicate
                                        </Flex>
                                      ),
                                    },
                                    {
                                      key: '4',
                                      danger: true,
                                      label: (
                                        <Popconfirm
                                          placement="top"
                                          arrow={false}
                                          title="Delete layer"
                                          icon={<AlertCircle style={{ color: 'red', marginRight: 10 }} width={15} />}
                                          description={<>Are you sure to delete <b>{component.getAttribute('name')}</b>?</>}
                                          onConfirm={() => deleteComponent(component)}
                                          okText="Yes"
                                          cancelText="No">
                                          <Flex align="center" gap={8}>
                                            <Trash2 />
                                            Delete
                                          </Flex>
                                        </Popconfirm>
                                      ),
                                    }
                                  ] as MenuProps['items']
                                }}
                              >
                                <Tooltip title="Actions"><MoreHorizontal /></Tooltip>
                              </Dropdown>
                            }
                          </Flex>
                        </Button>
                      )
                    })}
                  </Flex>

                </Flex>
              </Sider>
            </Layout>
          </Layout >
        </>
      )
    }
  </>
}
